import { render, staticRenderFns } from "./VisitDialog.vue?vue&type=template&id=67f88004"
import script from "./VisitDialog.vue?vue&type=script&lang=js"
export * from "./VisitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports